// components.application.manage.devices.manualEditDevice

export const MANUAL_EDIT_DEVICE = {
  divider: 'Manually Edit Device',
  fields: {
    model: 'Device Model',
    type: 'Device Type',
    os: 'Operating System',
    user: {
      id: '',
      firstName: '',
      lastName: '',
      email: ''
    }
  },
  buttons: {
    save: 'Save'
  }
};
